import { render } from "./LearnerLlmDialogic.vue?vue&type=template&id=4ff967ff&scoped=true"
import script from "./LearnerLlmDialogic.vue?vue&type=script&lang=js"
export * from "./LearnerLlmDialogic.vue?vue&type=script&lang=js"

import "./LearnerLlmDialogic.vue?vue&type=style&index=0&id=4ff967ff&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff967ff"]])

export default __exports__